<template>
    <transition name="fade">
        <div class="loadingMsg" v-show="show"></div>
    </transition>
</template>
<script>
export default {
    name: "loadingMsg",
    data() {
        return {
            show: false
        };
    },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.loadingMsg{
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(0deg);
    z-index: 100000;
    width: 50px;
    height: 50px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    @include loading($loading);
    animation: loading 1s linear infinite;
}
@keyframes loading {
    0%{
        transform: translate(-50%, -50%) rotate(0deg);
    }
    100%{
        transform: translate(-50%, -50%) rotate(360deg);
    }
}
</style>
